import { gql } from "@apollo/client";


export const SCHEDULE_WORKSHOP = gql`
mutation addWorkShop($input: CreateWorkshopInput!, $isFacilitator: Boolean!) {
  addWorkShop(input: $input, isFacilitator: $isFacilitator) {
    message
  }
}
`;

export const GET_ALL_SCHEDULED_WORKSHOPS = gql`
query getAllWorkshop($input: getWorkShopInput!) {
  getAllWorkShops(input: $input) {
    isActive
    wsDescription
    wsTopic
    wsId
    wsEndTime
    wsInteractionsPeriod
    wsTeachingPeriod
    wsStartTime
    wsStatus
    serverUrl
    botUrl
    meetingType
    feedsByWsId {
      nodes {
        fId
      }
    }
  }
}
`;

export const UPDATE_WORKSHOP = gql`
mutation updateWorkShop($input: UpdateWorkshopByWsIdInput!) {
  editWorkShop(input: $input) {
    message
  }
}
`;

export const DELETE_WORKSHOP = gql`
mutation deleteWorkShop($input: WorkShopInput!, $meetingType: MeetingType) {
  deleteWorkShop(input: $input, meetingType: $meetingType) {
    message
  }
}
`;

export const GET_WORKSHOP_BY_ID = gql`
query getWorkShopById($input: WorkShopInput!) {
  getWorkShopByWsId(input: $input) {
    isActive
    wsDescription
    wsEndTime
    wsId
    wsInteractionsPeriod
    wsStartTime
    wsStatus
    wsTeachingPeriod
    wsTopic
    wsCode
    wsParticipantsCount
    isRecordStart
    recordStartTime
    hostId
    serverUrl
    botUrl
    meetingType
    participantIds
    replicaMeetingIds
    showChat
    originalHostId
    mediaPipelineArn
    mediaPipelineId
  }
}
`;


export const UPDATE_WORKSHOP_MEETING_ID = gql`
mutation updateWorkShopCode($updateInput: WorkshopPatch!, $wsId: UUID!) {
  updateWorkshopByWsId(input: {workshopPatch: $updateInput, wsId: $wsId}) {
    clientMutationId
  }
}
`;


export const UPDATE_WORKSHOP_ENDED = gql`
mutation updateWorkShopStatus($wsId: UUID!) {
  updateWorkshopByWsId(input: {workshopPatch: {wsStatus: ENDED}, wsId: $wsId}) {
    clientMutationId
  }
}
`;

export const UPLOAD_WORKSHOP_VIDEO = gql`
mutation UploadMultipleWorkshopSessions(
  $saId: UUID!
  $sessions: [WorkshopSessionFileInput!]!
) {
  uploadMultipleWorkshopSessions(input: { saId: $saId, sessions: $sessions }) {
    files_processed
    uploaded_count
    failed_count
    results {
      error_message
      filename
      status
    }
  }
}
`;

export const EDIT_WORKSHOP_UPLOADED_VIDEO = gql`
mutation EditWorkshopSession($input: EditWorkshopSessionInput!) {
  editWorkshopSession(input: $input) {
    status
    message
    filename
  }
}
`;

export const GET_ALL_WORKSHOPS_VIDEOS = gql`
    query getWorkShopSessions(
        $searchInput: String = "%"
        $seType: [SessionType!] = [SAVED, UPLOADED]
        $limit: Int = null
        $offset: Int = null
    ) {
        allWorkshopSessions(
            filter: {
                and: [
                    { isDeleted: { equalTo: false } }
                    {
                        or: [
                            { seDescription: { likeInsensitive: $searchInput } }
                            {
                                workshopByWsId: {
                                    wsDescription: {
                                        likeInsensitive: $searchInput
                                    }
                                }
                            }
                        ]
                    }
                    { seType: { in: $seType } }
                    { seUrl: { isNull: false } }
                ]
            }
            first: $limit
            offset: $offset
            orderBy: CREATED_AT_DESC
        ) {
            nodes {
                seId
                seDescription
                createdAt
                seUrl
                seType
                seTitle
                sePlaybackTime
                fileinfo
                filetype
                workshopByWsId {
                    wsDescription
                    wsTopic
                    wsId
                }
                videosPlaybacktimesBySeId {
                    nodes {
                        playbackTime
                        vpId
                    }
                }
            }
            totalCount
        }

        overAllCount: allWorkshopSessions(
            filter: {
                and: [
                    { isDeleted: { equalTo: false } }
                    { seUrl: { isNull: false } }
                ]
            }
        ) {
            totalCount
        }
    }
`;


export const UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT  = gql`
mutation UpdateWorkshopParticipantsCount($input: WsParticipantsInput!) {
  updateWorkshopPartcipantsCount(input: $input)
}
`;

export const UPDATE_PLAY_BACK_TIME = gql`
mutation upsertVideosPlaybacktime($input: UpsertVideosPlaybacktimeInput!) {
  upsertVideosPlaybacktime(input: $input) {
    clientMutationId
  }
}
`;

export const SCHOOL_ADMIN_FACILITATOR_WORKSHOP = gql`
query getWorkShopSessions($searchInput: String = "%", $seType: [SessionType!] = [SAVED, UPLOADED], $limit: Int = null, $offset: Int = null) {
  allWorkshopSessions(
    filter: {
      and: 
      [
        {isDeleted: { equalTo: false }},
        {or: [{seDescription: {likeInsensitive: $searchInput}}, {workshopByWsId: {wsDescription: {likeInsensitive: $searchInput}}}]},
        {seType: {in: $seType}}, {seUrl: {isNull: false}},
        {facilitatorByFacId:{schoolAdminBySaIdExists:true}}
      ]
    }
    first: $limit
    offset: $offset
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      seId
      seDescription
      createdAt
      seUrl
      seType
      seTitle
      sePlaybackTime
      fileinfo
      filetype
      workshopByWsId {
        wsDescription
        wsTopic
        wsId
      }
      videosPlaybacktimesBySeId{
        nodes{
          playbackTime
          vpId
        }
      }
    }
    totalCount
  }

    overAllCount:allWorkshopSessions(
    filter: {and: [{isDeleted: { equalTo: false }}, {seUrl: {isNull: false}},{facilitatorByFacId:{schoolAdminBySaIdExists:true}}]}
  ) {
    totalCount
  }
}`;

export const SCHOOL_ADMIN_WORKSHOP = gql`
query getWorkShopSessions($searchInput: String = "%", $seType: [SessionType!] = [SAVED, UPLOADED], $limit: Int = null, $offset: Int = null) {
  allWorkshopSessions(
    filter: {
      and: 
      [
        {isDeleted: { equalTo: false }},
        {or: [{seDescription: {likeInsensitive: $searchInput}}, {workshopByWsId: {wsDescription: {likeInsensitive: $searchInput}}}]},
        {seType: {in: $seType}}, {seUrl: {isNull: false}},
        {schoolAdminBySaIdExists:true}
      ]
    }
    first: $limit
    offset: $offset
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      seId
      seDescription
      createdAt
      seUrl
      seType
      seTitle
      sePlaybackTime
      fileinfo
      filetype
      workshopByWsId {
        wsDescription
        wsTopic
        wsId
      }
      videosPlaybacktimesBySeId{
        nodes{
          playbackTime
          vpId
        }
      }
    }
    totalCount
  }

    overAllCount:allWorkshopSessions(
    filter: {and: [{isDeleted: { equalTo: false }}, {seUrl: {isNull: false}},{facilitatorByFacId:{schoolAdminBySaIdExists:true}}]}
  ) {
    totalCount
  }
}
`;

export const ADD_PARTICIPANT_WORKSHOP = gql`
  mutation addParticipantWorkshop($participantId: String!, $wsId: UUID!) {
    addParticipantWorkshop(participantId: $participantId, wsId: $wsId)
  }
`;

export const DELETE_PARTICIPANT_WORKSHOP = gql`
  mutation DeleteParticipantWorkshop($participantId: String!, $wsId: UUID!) {
  deleteParticipantWorkshop(participantId: $participantId, wsId: $wsId)
}
`;
